<template>
  <section class="produto-clube-vantagens-formulario">
    <div class="content">
      <Titulo :title="titulo" :description="descricao" />
      <Formulario
        :tipoProduto="tipoProduto"
        @click="salvar"
        :listaAnunciosBanner="listaAnunciosBanner"
        :loading="loading"
      />
    </div>
    <div class="py-5"></div>
  </section>
</template>

<script>
import Titulo from "@/components/TituloPaginas";
import Formulario from "@/components/cadastro/ClubeVantagens.vue";
export default {
  name: "CdlSaude",
  components: { Titulo, Formulario },
  data() {
    return {
      produto: {
        nome: "Clube de Vantagens",
        id: "Clube de Vantagens",
      },
      values: {},
      breadcrumb: [
        {
          nome: "Clube de Vantagens",
          id: "Clube de Vantagens",
          link: "/produto/clube-vantagens/painel",
        },
        {
          nome: "Formulário",
          id: "formulario",
          produto: "Clube de Vantagens",
        },
      ],
      titulo: null,
      descricao: null,
      listaAnunciosBanner: [],
      loading: false,
    };
  },
  computed: {
    urlParams() {
      return this.$route.params;
    },
  },
  methods: {
    validar() {
      this.$formulate.submit("Cadastro");
    },
    async salvar(result) {
      this.loading = true;
      if (result.props.tipoCadastro) {
        this.tipoProduto = result.props.tipoCadastro;

        if (result.props.tipoCadastro == "usuarios") {
          var i = 0;
          var usuarios = result.props.values;
          var cadUsuarios = [];

          do {
            if (usuarios["cpf_" + i] && usuarios["nome_" + i]) {
              let d = new Date();
              let date = new Date(d.valueOf() - d.getTimezoneOffset() * 60000);

              var dadosUsuario = {
                cpf: usuarios["cpf_" + i],
                nome: usuarios["nome_" + i],
                dataSolicitacao: date,
              };

              cadUsuarios.push(dadosUsuario);
            }
            i++;
          } while (i < result.props.nUsuarios);

          this.$http
            .post("/api/Clube/IncluirFuncionariosClubeVantagens", cadUsuarios)
            .then((response) => {
              if (response.status === 200) {
                this.$toast.open({
                  message: "Usuários cadastrados com sucesso!",
                  type: "success",
                  duration: 6000,
                });
                this.$router.push({ name: "clube-painel" });
              }
            })
            .catch((error) => {
              if (error.response.status === 401) {
                this.$router.push({ name: "login" });
              }
              console.error(error);
              this.$toast.open({
                message: "Erro ao cadatrar usuários, tente novamente.",
                type: "error",
              });
              this.loading = false;
            });
        } else if (result.props.tipoCadastro == "anuncio") {
          var dadosAnuncio = result.props.values;
          var imagens = result.props.imagens;

          // DADOS DO ACEITE
          if (!sessionStorage.ip) {
            fetch(process.env.VUE_APP_IP_API + "?format=json")
              .then((x) => x.json())
              .then(({ ip }) => {
                sessionStorage.ip = ip;
              });
          }

          let date = new Date();
          const data = this.$options.filters.converteData(date);

          const form = new FormData();

          for (let field in dadosAnuncio) {
            if (field != "enquadramento") {
              form.append(field, dadosAnuncio[field]);
            } else if (field == "enquadramento") {
              dadosAnuncio[field].forEach((el) => {
                form.append("enquadramento", el);
              });
            }
          }

          for (let field in imagens) {
            form.append(field, imagens[field].fileList[0]);
          }

          form.append("dtVersao", data);
          form.append("dtAceite", data);
          form.append("ipOrigem", sessionStorage.ip);
          form.append("browserData", navigator.appVersion);

          this.$http
            .post("/api/Clube/IncluirAnuncioClubeVantagens", form)
            .then((response) => {
              if (response.status === 200) {
                this.$toast.open({
                  message: "Anúncio cadastrado com sucesso!",
                  type: "success",
                  duration: 6000,
                });
                this.$router.push({ name: "clube-painel" });
              }
            })
            .catch((error) => {
              if (error.response.status === 401) {
                this.$router.push({ name: "login" });
              }
              console.error(error);
              this.$toast.open({
                message: error.response.data.mensagem,
                type: "error",
                duration: 6000,
              });
              this.loading = false;
            });
        } else if (result.props.tipoCadastro === "banner") {
          var dadosBanner = result.props.values;

          // DADOS DO ACEITE
          if (!sessionStorage.ip) {
            fetch(process.env.VUE_APP_IP_API + "?format=json")
              .then((x) => x.json())
              .then(({ ip }) => {
                sessionStorage.ip = ip;
              });
          }
          let date = new Date();
          const data = this.$options.filters.converteData(date);

          const form = new FormData();

          for (let field in dadosBanner) {
            if (field != "banner") {
              form.append(field, dadosBanner[field]);
            } else if (field == "banner") {
              form.append("banner", dadosBanner.banner.fileList[0]);
            }
          }

          form.append("dtVersao", data);
          form.append("dtAceite", data);
          form.append("ipOrigem", sessionStorage.ip);
          form.append("browserData", navigator.appVersion);

          this.$http
            .post("/api/Clube/IncluirBannerClubeVantagens", form)
            .then((response) => {
              if (response.status === 200) {
                this.$toast.open({
                  message: "Banner cadastrados com sucesso!",
                  type: "success",
                  duration: 6000,
                });
                this.$router.push({ name: "clube-painel" });
              }
            })
            .catch((error) => {
              if (error.response.status === 401) {
                this.$router.push({ name: "login" });
              }
              console.error(error);
              this.$toast.open({
                message: error.response.data.mensagem,
                type: "error",
                duration: 6000,
              });
              this.loading = false;
            });
        }
        //this.montarDados();
      } else {
        this.$router.push({ name: "clube-termo" });
      }
    },
    montarDados() {
      if (this.tipoProduto === "anuncio") {
        this.titulo = "Dados do Anúncio";
        this.descricao = "Informe os dados necessários para o anúncio.";
      }
      if (this.tipoProduto === "usuarios") {
        this.titulo = "Dados do Usuário";
        this.descricao =
          "Informe os dados necessários para o cadastro de usuários.";
      }
      if (this.tipoProduto === "banner") {
        this.titulo = "Dados do Banner";
        this.descricao = "Informe os dados necessários para o Banner.";
        this.$http
          .get(`/api/Clube/ConsultarAnunciosClubeVantagens`)
          .then((response) => {
            response.data.anuncios.forEach((el) => {
              this.listaAnunciosBanner.push({
                value: el.anuncioId,
                label: el.titulo,
              });
            });
          })
          .catch((error) => {
            if (error.response.status === 401) {
              this.$router.push({ name: "login" });
            }
            this.loading = false;
            this.error = error.response.data.mensagem;
          });
      }
      if (this.tipoProduto === "clube") {
        this.$router.push({ name: "clube-termo" });
      }
    },
  },
  filters: {
    converteData(data) {
      return (
        data.getFullYear() +
        "-" +
        ("0" + (data.getMonth() + 1)).slice(-2) +
        "-" +
        ("0" + data.getDate()).slice(-2) +
        "T" +
        ("0" + data.getHours()).slice(-2) +
        ":" +
        ("0" + data.getMinutes()).slice(-2) +
        ":" +
        ("0" + data.getSeconds()).slice(-2)
      );
    },
  },
  created() {
    this.$store.commit("UPDATE_PRODUTO", this.produto);
    this.$store.commit("UPDATE_BREADCRUMB", this.breadcrumb);
    this.tipoProduto = this.urlParams.tipoProduto;
    this.montarDados();
  },
};
</script>
